import { ChartElementHandler } from './chart.element-handler';

export class LineChartElementHandler extends ChartElementHandler<'chartLine'> {
  readonly type = 'chartLine';
  readonly flipXY = false;
}
